import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { setFiltersVisibility } from '../../../../../common/actions';
import { searchProducts, searchSuppliers, searchCategories } from '../../actions';
import { SearchableSelect } from '../../../../../common/ui';
import FilterModal from '../../../../../common/components/FilterModal';
import styles from './styles.module.css';

const FilterComp = ({
  common: { isFiltersOpen },
  stocks: { suggestProducts, suggestSuppliers, suggestCategories },
  setFiltersVisibility,
  filters,
  setFilters,
  searchProducts,
  searchSuppliers,
  searchCategories,
  selectedProduct,
  setselectedProduct,
  selectedSupplier,
  setselectedSupplier,
  selectedCategory,
  setselectedCategory,
}) => {
  const handleApply = () => {
    const newFilters = {};

    if (selectedProduct) {
      newFilters.product = selectedProduct;
    }

    if (selectedSupplier) {
      newFilters.supplier = selectedSupplier;
    }

    if (selectedCategory) {
      newFilters.category = selectedCategory;
    }

    setFilters(newFilters);
    setFiltersVisibility(false);
  };

  useEffect(() => {
    searchSuppliers();
  }, [searchSuppliers]);

  const supplierOptions = Array.isArray(suggestSuppliers) ? suggestSuppliers : [];

  const filterContent = (
    <>
      <div className={styles.filterOptionName}>By Product</div>
      <SearchableSelect
        async
        options={suggestProducts || []}
        getOptionLabel={(o) => [o.code, o.name].filter(Boolean).join(' – ') || o.barcode || '—'}
        getOptionValue={(o) => o.id}
        value={selectedProduct?.id}
        onChange={(id) => { if (!id) setselectedProduct(null); }}
        onSelect={(opt) => setselectedProduct(opt)}
        onSearch={(keyword) => searchProducts(keyword)}
        placeholder="Enter name, code or barcode"
        minSearchLength={1}
      />
      <div className={styles.spacer} />
      <div className={styles.filterOptionName}>By Supplier</div>
      <SearchableSelect
        options={supplierOptions}
        getOptionLabel={(o) => o.companyname}
        getOptionValue={(o) => o.id}
        value={selectedSupplier?.id}
        onChange={(id) => { if (!id) setselectedSupplier(null); }}
        onSelect={(opt) => setselectedSupplier(opt)}
        placeholder="Enter name"
      />
      <div className={styles.spacer} />
      <div className={styles.filterOptionName}>By Category</div>
      <SearchableSelect
        async
        options={suggestCategories || []}
        getOptionLabel={(o) => o.name}
        getOptionValue={(o) => o.id}
        value={selectedCategory?.id}
        onChange={(id) => { if (!id) setselectedCategory(null); }}
        onSelect={(opt) => setselectedCategory(opt)}
        onSearch={(keyword) => searchCategories(keyword)}
        placeholder="Enter name"
        minSearchLength={1}
      />
    </>
  );

  return (
    <FilterModal title="Filter by" onApply={handleApply}>
      {filterContent}
    </FilterModal>
  );
};

FilterComp.propTypes = {
  setFiltersVisibility: PropTypes.func.isRequired,
  searchProducts: PropTypes.func.isRequired,
  searchSuppliers: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  common: state.commonState,
  stocks: state.stocksState,
});

export default connect(mapStateToProps, {
  setFiltersVisibility,
  searchProducts,
  searchSuppliers,
  searchCategories,
})(FilterComp);
